function devtricker_getAuthorIdFromMeta() {
    const metaTag = document.getElementById("singleAuthorId");
    return metaTag ? metaTag.getAttribute("data-author-id") : null;
}

// return undefined for not logged user
function devtricker_getTheLoggedUserId() {

    let userIdElement = document.getElementById('user-id');

    if (userIdElement) {
        let userId = userIdElement.getAttribute('data-user-id');

        if (userId == '0') {
            return undefined;
        }

        return userId;
    }
}

// return 0 for not logged user
function devtricker_getTheUserId() {

    let userIdElement = document.getElementById('user-id');

    if (userIdElement) {
        return userIdElement.getAttribute('data-user-id');
    }
}

function devtricker_getPageGeneratedDate() {
    const metaTag = document.querySelector('meta[name="page-generated-time"]');
    if (metaTag && metaTag.content) {
        return new Date(metaTag.content);
    }
    return null;
}

function devtricker_getThePostId() {
    var element = document.getElementById('post-id');
    if (element) {
        return element.getAttribute('data-post-id');
    }

    return undefined;
}

function devtricker_openSocialLoginModal(event) {

    if (event) {
        event.stopPropagation();
    }

    const modalElement = document.getElementById('devtricker-login-modal');
    if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);

        modalInstance.show();
    }
}

function devtricker_safelyGetLocalStorage(key) {
    try {
        return localStorage.getItem(key);
    } catch (error) { }
}

function devtricker_safelySetLocalStorage(key, value) {
    try {
        localStorage.setItem(key, value);
    } catch (error) { }
}


function devtricker_safelyRemoveLocalStorage(key) {
    try {
        localStorage.removeItem(key);
    } catch (error) { }
}

function devtricker_formatLargeNumber(number = 0) {

    if (number === null) {
        number = 0;
    }

    if (number < 0) {
        return "0";
    } else if (number < 1000) {
        return number.toString();
    } else if (number < 1000000) {
        return Math.floor(number / 1000) + 'k';
    } else if (number < 1000000000) {
        return Math.floor(number / 1000000) + 'M';
    } else {
        return Math.floor(number / 1000000000) + 'B';
    }
}


function devtricker_warmUpCache() {
    fetch(window.location.href)
        .then(response => response.text())
        .then(html => {
            console.log('Page content reloaded successfully');
        })
        .catch(error => {
            console.error('Failed to reload page content', error);
        });
}

function devtricker_removePlaceholder(element) {
    element.classList.remove('placeholder');
}

function devtricker_showToast(toastElement, parentId) {

    const offcanvasBody = document.getElementById(parentId);

    if (offcanvasBody) {
        offcanvasBody.appendChild(toastElement);

        const toast = new bootstrap.Toast(toastElement);
        toast.show();

        setTimeout(() => {
            toastElement.remove();
        }, 2000);
    }
}

function devtricker_human_getTimeDiff(dateString) {
    const now = new Date();
    const utcDate = new Date(dateString);
    const diffInSeconds = Math.floor((now - utcDate) / 1000);

    if (diffInSeconds < 60) {
        return 'Now';
    } else if (diffInSeconds < 3600) {
        return Math.floor(diffInSeconds / 60) + 'm';
    } else if (diffInSeconds < 86400) {
        return Math.floor(diffInSeconds / 3600) + 'h';
    } else if (diffInSeconds < 604800) {
        return Math.floor(diffInSeconds / 86400) + 'd';
    } else if (diffInSeconds < 2592000) {
        return Math.floor(diffInSeconds / 604800) + 'w';
    } else if (diffInSeconds < 31536000) {
        return Math.floor(diffInSeconds / 2592000) + 'M';
    } else {
        return Math.floor(diffInSeconds / 31536000) + 'y';
    }
}





function devtricker_transformDivToInput(divElement) {
    if (divElement) {
        const inputElement = document.createElement('input');

        inputElement.type = divElement.getAttribute('type') || 'text';
        inputElement.id = divElement.id;
        inputElement.className = divElement.className;
        inputElement.placeholder = divElement.getAttribute('placeholder');
        inputElement.required = divElement.hasAttribute('required');
        inputElement.disabled = divElement.hasAttribute('disabled');
        inputElement.autocomplete = divElement.getAttribute('autocomplete');

        // Sempre define o atributo 'value', mesmo que esteja vazio
        inputElement.value = divElement.getAttribute('value') || '';

        if (divElement.hasAttribute('name')) {
            inputElement.name = divElement.getAttribute('name');
        }

        divElement.parentNode.replaceChild(inputElement, divElement);
    } else {
        console.error('Invalid element.');
    }
}